'use client';

import {
  type PropsWithChildren,
  type ReactElement,
  createContext,
  useSyncExternalStore,
} from 'react';

import { cookiebotStore } from '@/lib/cookiebot';
import { type Cookiebot } from '@/lib/cookiebot/types';

type Props = PropsWithChildren;

export const CookiebotContext = createContext<Cookiebot | null>(null);

export const CookiebotContextProvider = (props: Props): ReactElement => {
  const { children } = props;

  const cookiebot = useSyncExternalStore(
    cookiebotStore.subscribe,
    cookiebotStore.getSnapshot,
    cookiebotStore.getServerSnapshot
  );

  return (
    <CookiebotContext.Provider value={cookiebot}>
      {children}
    </CookiebotContext.Provider>
  );
};
